module.exports = __webpack_public_path__ + "img/jouluhero.343d0880.jpg";